/* eslint-disable  */

import { IRequestResponse } from 'interfaces/RequestResponse';
import api from 'configs/api';
import {
  IGridDailyBulletinDataResponse,
  IGridDailyBulletinData,
  IExportGridData,
  IGridCorrectivesData,
  IGridCorrectivesDataResponse,
} from 'interfaces/Grid';
import { IRequestListResponse } from 'interfaces/RequestListResponse';
import {
  IDailyBulletinMaintenenceTypeChart,
  IDailyBulletinMajorChart,
  IDailyBulletinPreventiveCorrectiveChart,
  IDailyBulletinStatusChart,
} from 'interfaces/Chart';

const endpointUrl = 'daily-bulletin';

export const postDailyBulletinGrid = async (qs, params) => {
  const url = `${endpointUrl}/grid?${qs}`;
  const { data } = await api.post<
    IRequestResponse<IGridDailyBulletinDataResponse<IGridDailyBulletinData[]>>
  >(url, params);
  return data;
};

export const postDailyBulletinChart = async (params: {
  installationIds: number[];
  supplierExecutors: number[];
  date: string;
}) => {
  const url = `${endpointUrl}/chart/maintenance-type/filter`;
  const { data } = await api.post<
    IRequestResponse<IDailyBulletinMaintenenceTypeChart>
  >(url, params);
  return data;
};

export const postDailyBulletinMajorChart = async (params: {
  installationIds: number[];
  supplierExecutors: number[];
  date: string;
}) => {
  const url = `${endpointUrl}/chart/major-correctives-execute/filter`;
  const { data } = await api.post<IRequestResponse<IDailyBulletinMajorChart>>(
    url,
    params,
  );
  return data;
};

export const postDailyBulletinPreventiveCorrectiveChart = async (params: {
  installationIds: number[];
  supplierExecutors: number[];
  date: string;
}) => {
  const url = `${endpointUrl}/chart/preventive-corrective/filter`;
  const { data } = await api.post<
    IRequestResponse<IDailyBulletinPreventiveCorrectiveChart>
  >(url, params);
  return data;
};

export const postDailyBulletinStatusChart = async (params: {
  installationIds: number[];
  supplierExecutors: number[];
  date: string;
}) => {
  const url = `${endpointUrl}/chart/status/filter`;
  const { data } = await api.post<IRequestResponse<IDailyBulletinStatusChart>>(
    url,
    params,
  );
  return data;
};

export const postCorrectivesGrid = async (qs, params) => {
  const url = `${endpointUrl}/grid/major-correctives?${qs}`;
  const { data } = await api.post<
    IRequestResponse<IGridCorrectivesDataResponse<IGridCorrectivesData[]>>
  >(url, params);
  return data;
};

export const putGridCorrectives = async params => {
  const url = `${endpointUrl}/grid/major-correctives`;
  const { data } = await api.put<IRequestResponse<null>>(url, params);
  return data;
};



export const postPauseDailyBulletin = async params => {
  const url = `${endpointUrl}/pause`;
  const { data } = await api.post<IRequestResponse<null>>(url, params);
  return data;
};

export const postFinishDailyBulletin = async params => {
  const url = `${endpointUrl}/finish`;
  const { data } = await api.post<IRequestResponse<null>>(url, params);
  return data;
};

export const postFinishPlanActivitiesDailyBulletin = async params => {
  const url = `${endpointUrl}/finish/plan`;
  const { data } = await api.post<IRequestResponse<null>>(url, params);
  return data;
};

export const postFinishRealActivitiesDailyBulletin = async params => {
  const url = `${endpointUrl}/finish/real`;
  const { data } = await api.post<IRequestResponse<null>>(url, params);
  return data;
};

export const postFinishDiverseActivitiesDailyBulletin = async params => {
  const url = `${endpointUrl}/finish/diverse`;
  const { data } = await api.post<IRequestResponse<null>>(url, params);
  return data;
};

export const postStartDailyBulletin = async params => {
  const url = `${endpointUrl}/start`;
  const { data } = await api.post<IRequestResponse<null>>(url, params);
  return data;
};

export const postUnpauseDailyBulletin = async params => {
  const url = `${endpointUrl}/unpause`;
  const { data } = await api.post<IRequestResponse<null>>(url, params);
  return data;
};

export const deleteDailyBulletin = async params => {
  const url = `${endpointUrl}/delete`;
  const { data } = await api.delete<IRequestResponse<null>>(url, {
    data: params,
  });
  return data;
};

export const postExportDailyBulletinGrid = async (qs, params) => {
  const url = `${endpointUrl}/grid/excel?${qs}`;
  const { data } = await api.post<IExportGridData>(url, params);
  return data;
};

export const postExportPdfDailyBulletinGrid = async (qs, params) => {
  const url = `${endpointUrl}/pdf`;
  const { data } = await api.post<IRequestResponse<string>>(url, params);
  return data;
};

export const postCancelDailyBulletin = async params => {
  const url = `${endpointUrl}/cancel`;
  const { data } = await api.post<IRequestResponse<null>>(url, params);
  return data;
};

export const postActivity = async params => {
  const url = `${endpointUrl}/add`;
  const { data } = await api.post<IRequestListResponse<null>>(url, params);
  return data;
};

export const postUpdatebulletinStatus = async params => {
  const url = `${endpointUrl}/updateBulletinStatus`;
  const { data } = await api.put<any>(url, params);
  return data;
};

export const postObservationField = async params => {
  const url = `${endpointUrl}/updateObservationField`;
  const { data } = await api.put<any>(url, params);
  return data;
};

export const postAddBoletim = async params => {
  console.log(params);
  const url = `${endpointUrl}/addAndReplan`;
  const { data } = await api.post<IRequestResponse<null>>(url, params);
  return data;
};

export const postReplanDailyBulletin = async params => {
  const url = `${endpointUrl}/replan`;
  const { data } = await api.post<IRequestResponse<null>>(url, params);
  return data;
};